export const resultRoutesConfig = {
    EARNING: 'earning',
    SUMMARY: 'summary',
} as const;
